import { ReactNode } from 'react';

import { Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';

import {
  createResourceLinkExtension,
  extractLastNameComponent,
  isResourceName,
} from '@spotify/confidence-core-react';

import { confidencePulsePlugin } from '../plugin';
import { pulsesPageRouteRef } from '../routes';

interface PulseResourceLinkProps {
  name: string;
  text: ReactNode;
  className?: string;
}

const PulseResourceLink = ({
  name,
  text,
  className,
}: PulseResourceLinkProps) => {
  const pulsesPage = useRouteRef(pulsesPageRouteRef);
  const pulseId = extractLastNameComponent(name);

  if (!pulsesPage || !pulseId) {
    return <>{text}</>;
  }

  const to = `${pulsesPage()}/${pulseId}`;

  return (
    <Link to={to} className={className}>
      {text}
    </Link>
  );
};

export const PulseResourceLinkExtension = confidencePulsePlugin.provide(
  createResourceLinkExtension({
    id: 'pulse-resource-link',
    predicate: ({ name }) => isResourceName(name, 'pulses'),
    render: ({ name, text, className }) => (
      <PulseResourceLink name={name} text={text} className={className} />
    ),
  }),
);
